import React, { memo } from 'react';
import PropTypes from 'prop-types';
import StateTransitionListItemComponent from './StateTransitionListItemComponent';

const StateTransitionListComponent = ({ localState, onEdit, onSave, onRemove, dispatch, changed }) => {
  const getPagedStateTransitions = () => {
    let pager = localState.pager;
    var begin = pager.page * pager.pageSize;
    var end = begin + pager.pageSize;
    const list = localState.documentTypeWithStateTransitions.stateTransitions
      ? [...localState.documentTypeWithStateTransitions.stateTransitions]
      : [];
    return list.slice(begin, end);
  };

  return (
    <StateTransitionListItemComponent
      changed={changed}
      stateTransitions={getPagedStateTransitions()}
      userGroups={localState.userGroups}
      changedStateTransitionsPermissions={localState.changedStateTransitionsPermissions}
      onEdit={onEdit}
      onSave={onSave}
      onRemove={onRemove}
      dispatch={dispatch}
    />
  );
};

StateTransitionListComponent.propTypes = {
  localState: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  changed: PropTypes.bool
};

export default memo(StateTransitionListComponent);
